<template>
    <div class="footer">   
        <p>Copyright &copy; {{year}} Renox Technology Pty Ltd &nbsp;&nbsp;</p>
    </div>
  </template>
  
  <script>
export default {
  name: 'MainBottomFooter',
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
  </script>
  <style scoped lang="scss">
  .footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    padding: 10px;
    background-color: #f9f9f9;
}

  </style>
  